import { defineComponent as _defineComponent } from 'vue'
import { FiltersConfiguration } from '@/modules/ColorModule/helpers/ColorModuleHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionalColorModuleFilters',
  props: {
    filters: null,
    activeTab: { type: [String, Boolean], default: false },
    showLatestColors: { type: Boolean, default: false }
  },
  emits: ['filterChange'],
  setup(__props: any, { emit }) {

const props = __props as { filters: any, activeTab: string | boolean, showLatestColors: boolean };




const optionalFiltersConfiguration = FiltersConfiguration.filter((filter) => !filter.isMandatory);

const isFilterDisabled = (filter: any): boolean => {
    const isFilterActive = filter.isActive(props.activeTab as string);
    const isColorTableActive = props.activeTab === 'color-search';
    const isShowingLatestColors = props.showLatestColors;

    return !isFilterActive || (isShowingLatestColors && isColorTableActive);
};

const onFilterChange = (value: string, type: string, option: any) => {
    emit('filterChange', { value, type, id: option?.key || '' });
};

return { __sfc: true,props, emit, optionalFiltersConfiguration, isFilterDisabled, onFilterChange }
}

})